import * as React from "react";

function SvgPaw(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 452.589 452.59"
      {...props}
    >
      <path d="M375.786 368.016c-1.022 62.699-34.434 85.385-69.898 83.283-35.465-2.093-60.132-18.537-85.32-18.537l-1.032.576c-25.188 0-49.854 17.021-85.319 19.114-35.466 2.093-68.876-19.449-69.898-82.148 2.056-57.565 45.911-61.798 83.265-129.8 32.891-59.881 71.954-55.035 71.954-55.035h1.03s39.4-4.586 71.955 55.035c37.175 68.095 81.207 69.945 83.263 127.512zm-219.583-208.38c31.413-2.382 54.172-40.021 50.832-84.071-3.34-44.049-31.514-77.828-62.927-75.446-31.413 2.382-54.172 40.022-50.832 84.071 3.34 44.049 31.513 77.828 62.927 75.446zm119.061.765c30.698 8.368 65.097-19.742 76.83-62.786 11.732-43.044-3.642-84.722-34.339-93.09-30.698-8.368-65.097 19.742-76.829 62.786-11.733 43.043 3.64 84.722 34.338 93.09zm142.222-34.464c-26.732-7.288-56.688 17.19-66.905 54.674-10.217 37.484 3.171 73.777 29.903 81.064 26.733 7.287 56.688-17.191 66.906-54.675 10.218-37.482-3.17-73.776-29.904-81.063zm-315.478 54.671c-10.218-37.482-40.172-61.961-66.905-54.674s-40.122 43.581-29.904 81.064c10.218 37.482 40.173 61.961 66.906 54.674 26.732-7.286 40.12-43.58 29.903-81.064z" />
    </svg>
  );
}

export default SvgPaw;
